import React, { useMemo, useState } from 'react';
import { region1AllotmentTables } from '../data/allotmentTables';

const AllotmentSummary = () => {
  const years = useMemo(
    () => Object.keys(region1AllotmentTables).sort((a, b) => Number(b) - Number(a)),
    []
  );
  const [selectedYear, setSelectedYear] = useState(years[0] || '');
  const table = region1AllotmentTables[selectedYear];

  if (!table) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
        <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-8 max-w-md">
          <p className="text-yellow-700 dark:text-yellow-300 text-center">No allotment summary is available.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-2">Region 1 Allotment Summary</h1>
          <p className="text-lg text-gray-600 dark:text-gray-400">
            Source: {table.source} | As of {new Date(table.asOf).toLocaleDateString()}
          </p>
          <div className="mt-4">
            <label htmlFor="allotment-year" className="text-sm font-medium text-gray-700 dark:text-gray-300 mr-3">
              Season Year
            </label>
            <select
              id="allotment-year"
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
              className="px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
            >
              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">{table.title}</h2>
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
              <thead className="bg-gray-50 dark:bg-gray-900">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Level</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Age Group</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Allotment</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">At States</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">AZ</th>
                </tr>
              </thead>
              <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                {table.rows.map((row) => (
                  <tr key={`${row.level}-${row.ageGroup}`}>
                    <td className="px-4 py-3 text-sm text-gray-900 dark:text-white">{row.level}</td>
                    <td className="px-4 py-3 text-sm text-gray-600 dark:text-gray-300">{row.ageGroup}</td>
                    <td className="px-4 py-3 text-sm text-gray-900 dark:text-white">{row.allotment}</td>
                    <td className="px-4 py-3 text-sm text-gray-900 dark:text-white">{row.competingAtStates}</td>
                    <td className="px-4 py-3 text-sm text-gray-600 dark:text-gray-300">{row.allQualify ? 'All Qualify' : row.az}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="bg-gray-50 dark:bg-gray-900">
                <tr>
                  <td className="px-4 py-3 text-sm font-semibold text-gray-900 dark:text-white" colSpan={2}>Totals</td>
                  <td className="px-4 py-3 text-sm font-semibold text-gray-900 dark:text-white">{table.totals.allotment}</td>
                  <td className="px-4 py-3 text-sm font-semibold text-gray-900 dark:text-white">{table.totals.competingAtStates}</td>
                  <td className="px-4 py-3"></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllotmentSummary;

